import { Check, Minus, X } from "lucide-react";

const cols = ["Cloud memory cloud", "Local RAG toolkit", "Smritium"];

const rows = [
  ["Corpus stays on your device", "no", "yes", "yes"],
  ["Content-addressed, reproducible citations", "no", "no", "yes"],
  ["Multi-signal rehydration (semantic · temporal · relational)", "partial", "no", "yes"],
  ["Cite-or-abstain — no hallucinated sources", "no", "partial", "yes"],
  ["Works fully offline", "no", "partial", "yes"],
  ["Consent-gated capture (approval inbox)", "no", "no", "yes"],
  ["Egress audit + PII redaction (Membrane)", "no", "no", "yes"],
  ["Data residency by construction (DPDP / GDPR)", "partial", "yes", "yes"],
  ["Flat / free-core pricing (not metered per token)", "no", "yes", "yes"],
];

function Cell({ v, hi }) {
  const base = `flex h-full items-center justify-center py-4 ${hi ? "bg-ember/[0.06]" : ""}`;
  if (v === "yes")
    return (
      <div className={base}>
        <Check size={18} className={hi ? "text-ember" : "text-paper/70"} />
      </div>
    );
  if (v === "partial")
    return (
      <div className={base}>
        <Minus size={18} className="text-mute/60" />
      </div>
    );
  return (
    <div className={base}>
      <X size={16} className="text-mute/30" />
    </div>
  );
}

export default function CompareMatrix() {
  return (
    <div className="overflow-x-auto" data-testid="compare-matrix">
      <div className="min-w-[660px] overflow-hidden rounded-2xl border border-white/10">
        <div className="grid grid-cols-[1.8fr_1fr_1fr_1fr] items-stretch border-b border-white/10 bg-white/5">
          <div className="px-6 py-5 text-xs uppercase tracking-overline text-mute">
            Capability
          </div>
          {cols.map((c, i) => (
            <div
              key={c}
              className={`px-4 py-5 text-center text-sm font-medium ${
                i === 2 ? "bg-ember/10 text-ember" : "text-mute"
              }`}
            >
              {i === 2 ? (
                <span className="inline-flex items-center justify-center gap-2">
                  <img src="/brand/smritium-mark-white.png" alt="" className="h-4 w-4" />
                  {c}
                </span>
              ) : (
                c
              )}
            </div>
          ))}
        </div>
        {rows.map((r, ri) => (
          <div
            key={r[0]}
            className={`grid grid-cols-[1.8fr_1fr_1fr_1fr] items-stretch ${
              ri % 2 ? "bg-white/[0.015]" : ""
            }`}
          >
            <div className="flex items-center px-6 py-4 text-sm text-paper">{r[0]}</div>
            <Cell v={r[1]} />
            <Cell v={r[2]} />
            <Cell v={r[3]} hi />
          </div>
        ))}
      </div>
    </div>
  );
}
